import React from "react";
import Container from "../../shared/components/UIElements/Container";
import FileList from "../components/FileList";
import Heading from "../../shared/components/UIElements/Heading";
import Button from "../../shared/components/FormElements/Button";
import { PlusIcon, ArrowRightIcon } from "@heroicons/react/20/solid";

const OVOs = () => {
	return (
		<Container>
			<div className="pb-12">
				<Heading>ZZP</Heading>
				
				<div className="mt-8">
					<Heading size="3">Wat wil je maken?</Heading>
					
					<div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
						{/* Option 1: Overeenkomst van opdracht */}
						<div className="bg-white border border-gray-200 rounded-2xl p-6">
							<h4 className="font-semibold text-lg mb-2">Overeenkomst van opdracht</h4>
							<Button to="/nieuw/ovo" classNames="flex items-center mt-3 w-fit">
								<PlusIcon className="w-5 h-5 mr-2 -ml-2" />
								Nieuwe OVO
							</Button>
						</div>

						{/* Option 2: Contract ZZP naar loondienst */}
						<div className="bg-white border border-gray-200 rounded-2xl p-6">
							<h4 className="font-semibold text-lg mb-2">Contract ZZP naar loondienst</h4>
							<p className="text-gray-600 text-sm mb-3">
								Deze vind je bij het kopje 'contracten'. Kies bij de eerste stap voor een provisiecontract.
							</p>
							<Button to="/contracten" classNames="flex items-center mt-3 w-fit">
								<ArrowRightIcon className="w-5 h-5 mr-2 -ml-2" />
								Ga naar contracten
							</Button>
						</div>
					</div>
				</div>
			</div>
			
			<div className="xl:flex">
				<div className="xl:w-2/5 bg-slate-200 bg-opacity-50 px-10 py-8 rounded-3xl h-fit">
					<Heading size="3">Concepten</Heading>
					<p className="text-gray-500 text-base mt-1 mb-4">
						Ga verder waar je gebleven bent. We slaan je concepten
						tussentijds op.
					</p>
					<FileList fileType="ovo" status="draft" limit="5" />
				</div>
				<div className="xl:w-3/5 xl:pl-12 pt-8">
					<FileList fileType="ovo" />
				</div>
			</div>
		</Container>
	);
};

export default OVOs;
